// Business identifiers shown in the footer and legal pages.
// TODO (Matthew): paste the real ABN here (or set REACT_APP_BUSINESS_ABN). Hidden while empty.
export const BUSINESS_ABN = (process.env.REACT_APP_BUSINESS_ABN || "").trim();
